<ng-container *ngIf="validationSummary">
  <a
    mat-list-item
    [class.active]="validationSummary.errors"
    (click)="focusControl(validationSummary.control)"
  >
    <div class="validation-info">
      <span class="control-key">
        {{ displayKey }}
      </span>

      <ng-container *ngIf="validationSummary.errors as errors">
        <ng-container *ngFor="let error of errors | keyvalue">
          <span class="error-key">{{ error.key }}</span>
        </ng-container>
      </ng-container>
    </div>
  </a>

  <ng-container *ngIf="validationSummary.children?.length">
    <mat-list>
      <ng-container *ngFor="let validation of validationSummary.children">
        <sd-portal-error-summary-item
          [validationSummary]="validation"
          [parentKey]="validationSummary.key"
          (controlSelected)="controlSelected.emit()"
        ></sd-portal-error-summary-item>
      </ng-container>
    </mat-list>
  </ng-container>
</ng-container>
